import React from 'react';
import {Box, Link as MuiLink, Typography} from '@material-ui/core';
import {CallMade} from '@material-ui/icons';
import {Form, FormikProps} from 'formik';
import {Link} from 'react-router-dom';
import {EfeButtonPrimary, EfeErrorMsg, EfeFieldText, EfePasswordField} from 'components';
import {BottomContent, MainContent} from 'layouts/commons';
import {Messages} from 'commons/messages';
import {FlexBoxClasses} from 'assets/tss/commons/Flex';
import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import {LoginValues} from 'commons/models';
import {useSpinner} from 'hooks';

InnerFormLogin.propTypes = {
    createUser: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

function InnerFormLogin(
    props: InferPropTypes<typeof InnerFormLogin.propTypes> & FormikProps<LoginValues>
) {
    const {isSubmitting, values, errors, handleBlur, handleChange, isLoading, createUser} = props;

    const HeadInfo = (
        <Typography variant='body1' color='textPrimary'>
            {Messages.getAppMessage('login')}
        </Typography>
    );

    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            <MainContent>
                {useSpinner(isLoading)}
                <Box flexGrow={0}>{HeadInfo}</Box>
                <Box sx={FlexBoxClasses}>
                    <Box>
                        <EfeFieldText
                            fullWidth
                            id='username'
                            name='username'
                            label='Usuario'
                            placeholder='Ej. VECJ880326AH1'
                            value={values.username}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!errors.username}
                            helperText={errors.username}
                            inputProps={{
                                style: {
                                    textTransform: 'uppercase',
                                },
                            }}
                        />
                    </Box>
                    <Box pt={4}>
                        <EfePasswordField
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            value={values.password}
                            error={!!errors.password}
                        />
                        {errors.password && <EfeErrorMsg message={errors.password} />}
                    </Box>
                    <Box pt={4}>
                        <Typography variant='body1' color='textPrimary'>
                            <MuiLink
                                style={{cursor: 'pointer'}}
                                onClick={createUser}
                                variant='body1'
                                color='primary'
                                underline='always'>
                                {'Crear cuenta'}
                            </MuiLink>
                        </Typography>
                    </Box>
                    <Box pt={4}>
                        <Typography variant='body1' color='textPrimary'>
                            <MuiLink
                                component={Link}
                                color='primary'
                                to={'/admin/recover-password'}>
                                {'\u00bfOlvidaste tu contrase\u00f1a?'}
                            </MuiLink>
                        </Typography>
                    </Box>
                </Box>
            </MainContent>
            <BottomContent>
                <EfeButtonPrimary disabled={isSubmitting} endIcon={<CallMade />} type='submit'>
                    {'Iniciar Sesi\u00f3n'}
                </EfeButtonPrimary>
            </BottomContent>
        </Form>
    );
}

export default InnerFormLogin;
